module.exports = "/_next/static/images/60f9621579cb6c3f312f457e3ec67a88-cardMoradita.svg.webp";